import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@app/router/routes'

// Public (no-login) owner signing pages. No `meta.requiresAuth`, so the global
// guard lets anonymous users through; the secure link token is the credential.
export const publicSigningRoutes: RouteRecordRaw[] = [
  {
    path: routes.PUBLIC_AGREEMENT_SIGN,
    name: 'PUBLIC_AGREEMENT_SIGN',
    component: () => import('./PublicAgreementSignPage.vue'),
    meta: { title: 'Sign agreement' },
  },
  {
    path: routes.PUBLIC_AGREEMENT_SIGN_RETURN,
    name: 'PUBLIC_AGREEMENT_SIGN_RETURN',
    component: () => import('./PublicAgreementSignReturnPage.vue'),
    meta: { title: 'Finalising signature' },
  },
]
